var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// Bootstrap 5 (data API via data-bs-* attrs)
// const Tab = require('bootstrap/js/dist/tab');
// const Tooltip = require('bootstrap/js/dist/stooltip');
require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/offcanvas');
require('bootstrap/js/dist/scrollspy');

require('bootstrap-select');
// require('owl.carousel');

const { initTestimonialSwipers } = require('./testimonial-swiper');
const { initMainNav } = require('./main-nav');
const { initReveal } = require('./reveal');
const { initContactSwap } = require('./contact-swap');

$(function () {
    // Isotope masonry (products / work grids)
    $('.grid').each(function () {
        var $module = $(this);

        $module.isotope({
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
            masonry: {
                columnWidth: 0,
                gutter: 0,
            },
        });

        // Relayout as lazyloaded images arrive
        this.addEventListener(
            'load',
            function () {
                $module.isotope('layout');
            },
            true
        );
    });

    // Clients panel expand / collapse
    if ($('#clients--container').length && $('#btn-more-clients').length) {
        var $clientsGrid = $('#clients--container');
        var needsToggle = $clientsGrid.find('.row > .col').length > 8;

        if (!needsToggle) {
            $('#btn-more-clients, #btn-less-clients').addClass('d-none');
        } else {
            $clientsGrid.addClass('is-collapsed');

            $('#btn-more-clients').on('click', function (e) {
                e.preventDefault();
                $clientsGrid.removeClass('is-collapsed');
                $(this).addClass('d-none').attr('aria-expanded', 'true');
                $('#btn-less-clients').removeClass('d-none').attr('aria-expanded', 'true');
            });

            $('#btn-less-clients').on('click', function (e) {
                e.preventDefault();
                $clientsGrid.addClass('is-collapsed');
                $(this).addClass('d-none').attr('aria-expanded', 'false');
                $('#btn-more-clients').removeClass('d-none').attr('aria-expanded', 'false');
            });
        }
    }

    // Keep sticky sidebars / page-scroll clear of the fixed scroll-header
    var updateHeaderStickyOffset = function () {
        var $scrollHeader = $('#scroll-header');
        var height = $scrollHeader.length
            ? $scrollHeader.outerHeight()
            : $('#header').outerHeight();

        if (!height) {
            return;
        }

        document.documentElement.style.setProperty(
            '--header-sticky-offset',
            Math.ceil(height) + 'px'
        );
    };

    // Footer reveal spacer — match fixed footer stack height (measure inner content, not fixed box)
    var updateRevealSpacer = function () {
        var $reveal = $('.reveal-wrapper .footer-reveal');
        if (!$reveal.length) {
            return;
        }
        $('.reveal-spacer').css('height', $reveal.outerHeight());
    };

    // Mobile parallax image shift
    /* var updateImgMove = function () {
        if ($(window).width() > 500) {
            $('.img-move--item').css('left', 'auto');
            return;
        }

        var windowTop = $(window).scrollTop();

        $('.img-move--container').each(function () {
            var elementTop = $(this).offset().top;
            $(this)
                .find('.img-move--item')
                .css({ left: -(windowTop - elementTop) - 375 });
        });
    }; */

    updateRevealSpacer();

    $(window).on('load resize', function () {
        // updateStickyNav();
        updateRevealSpacer();
        // updateImgMove();
    });

    $(window).on('scroll', function () {
        // updateImgMove();
    });

    // Carousels — init once
    initTestimonialSwipers();

    /* $('.owl-carousel-testimonial-grey').owlCarousel({
        margin: 0,
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 6000,
        items: 1,
    });

    $('.image-carousel').owlCarousel({
        margin: 10,
        nav: false,
        dots: false,
        loop: false,
        autoplay: false,
        smartSpeed: 1000,
        autoplayTimeout: 6000,
        items: 3,
        autoWidth: true,
        center: false,
    }); */

    // Tooltips (BS5 requires explicit init)
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
        Tooltip.getOrCreateInstance(el);
    });

    // Tab deep-linking (#!tab-id)
    // if (location.hash.substr(0, 2) === '#!') {
    //     var tabEl = document.querySelector(
    //         "a[href='#" + location.hash.substr(2) + "']"
    //     );
    //     if (tabEl) {
    //         Tab.getOrCreateInstance(tabEl).show();
    //     }
    //     $('.tab-pane.active #name').focus();
    // }

    // $("a[data-bs-toggle='tab']").on('shown.bs.tab', function (e) {
    //     var hash = $(e.target).attr('href');
    //     if (hash && hash.substr(0, 1) === '#') {
    //         location.replace('#!' + hash.substr(1));
    //         $('.tab-pane.active #name').focus();
    //     }
    // });

    // Smooth in-page scroll
    $(document).on('click', '.page-scroll', function (event) {
        var href = $(this).attr('href');
        if (!href) {
            return;
        }

        var target = href.replace(/^\//, '');
        var $target = $(target);
        if (!$target.length) {
            return;
        }

        var headerOffset =
            $('#scroll-header').outerHeight() ||
            $('#header').outerHeight() ||
            0;

        $('html, body')
            .stop()
            .animate(
                { scrollTop: $target.offset().top - headerOffset },
                750,
                'easeInOutExpo'
            );

        event.preventDefault();
    });

    updateHeaderStickyOffset();
    $(window).on('resize', updateHeaderStickyOffset);

    initMainNav();
    initReveal();
    initContactSwap();

    // Universal Analytics click tracking (no-op if ga is absent)
    if (typeof ga !== 'undefined') {
        $('a[href^="tel:"]').on('click', function () {
            var value = $(this).attr('href').split(':');
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        $('a[href^="mailto:"]').on('click', function () {
            var value = $(this).attr('href').split(':');
            ga('send', 'event', 'Email', 'click', value[1]);
        });
    }

    $('.selectpicker').selectpicker();

    scrollToFormError();
});

function scrollToFormError() {
    var formStr = '#form-';
    if (!window.location.hash || window.location.hash.indexOf(formStr) === -1) {
        return;
    }

    var formEl = window.location.hash;
    if (!$(formEl).length) {
        return;
    }

    var offsetSize = ($('#main-nav').height() || 0) + 50;
    $('html, body').animate(
        { scrollTop: $(formEl).offset().top - offsetSize },
        1000
    );
}
